<template>
  <div :style="scaleStyle" ref="previewMain" :class="{'is-sample': isSample, 'is-preview': !isSample}">
    <div class="doc-paper preview keirekisho" :id="idPrefix + 'preview-page-01'">
      <div class="keirekisho-wapper">
        <div class="keirekisho-header">
          <h1 class="title">職務経歴書</h1>
          <div class="date data text-right" :data-highlight="highlightMessage" @click="goCardTo('create-date')"
            :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span>
          </div>
          <div class="data text-right" :data-highlight="highlightMessage" @click="goCardTo('profile')"
            :class="highLightClass('profile')">
            <span class="name">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</span>
          </div>
        </div>
        <div class="keirekisho-content">
          <h2 v-if="formatData.jobSummary">経歴要約</h2>
          <div class="job-summary" :data-highlight="highlightMessage" @click="goCardTo('job-summary')"
            :class="highLightClass('job-summary')">
            <pre :style="formatData.selFontStyle">{{ formatData.jobSummary }}</pre>
          </div>
          <h2 v-if="formatData.skillsToUse&&formatData.skillsToUse.length" id="skills">活かせるスキル・経験</h2>
          <div class="skills-to-use" :data-highlight="highlightMessage" @click="goCardTo('skills-to-use')"
            :class="highLightClass('skills-to-use')">
            <dl v-for="(item, index) in formatData.skillsToUse" :key="index" :style="formatData.selFontStyle">
              <dt>{{ item.skillname }} <template v-if="item.years">/ 実務経験 {{ item.years }}年以上</template></dt>
              <dd>{{ item.description }}</dd>
            </dl>
          </div>
          <h2 v-if="formatData.jobHistories&&formatData.jobHistories.length" id="job-history">職務経歴</h2>
          <div class="job-history" :data-highlight="highlightMessage" @click="goCardTo('job-history')"
            :class="highLightClass('job-history')">
            <div v-for="item in formatData.jobHistories" :key="item.uuid">
              <h3 v-if="item.companyName || item.startYear || item.startMonth || item.endYear || item.endMonth"
                class="company-name" :style="formatData.selFontStyle">{{ item.companyName }}
                <span v-if="item.isContinuing && item.startYear && item.startMonth">{{ item.startYear}}年 {{
                  item.startMonth }}月 〜 在職中</span>
                <span v-else-if="item.isContinuing && item.startYear && !item.startMonth">{{ item.startYear}}年 〜
                  在職中</span>
                <span v-else-if="item.isContinuing && !item.startYear && item.startMonth">{{ item.startMonth }}月 〜
                  在職中</span>
                <span v-else-if="item.isContinuing && !item.startYear && !item.startMonth">在職中</span>
                <span v-else><template v-if="item.startYear">{{ item.startYear}}年</template> <template
                    v-if="item.startMonth">{{ item.startMonth }}月</template> <template
                    v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{
                    item.endYear}}年</template> <template v-if="item.endMonth">{{ item.endMonth }}月</template></span>
              </h3>
              <!-- <h3>{{ item.companyName }}<span>{{ item.startYear}}年{{ item.startMonth }}月 〜 現在に至る</span></h3> -->
              <div class="organization" v-if="item.businessArea || item.numberOfEmployees || item.capitalStock"
                :style="formatData.selFontStyle">
                <p v-if="item.businessArea">
                <pre :style="formatData.selFontStyle">事業内容：{{ item.businessArea}}</pre>
                </p>
                <p v-if="item.capitalStock && item.numberOfEmployees">資本金：{{ item.capitalStock }}万円、従業員数：{{
                  item.numberOfEmployees }}名</p>
                <p v-else-if="item.capitalStock && !item.numberOfEmployees">資本金：{{ item.capitalStock }}万円</p>
                <p v-else-if="!item.capitalStock && item.numberOfEmployees">従業員数：{{ item.numberOfEmployees }}名</p>
              </div>
              <h4 v-if="item.projects&&item.projects.length&&!formatData.notDisplayOmonajiseki">主な実績</h4>
              <div v-for="(item, index) in item.projects" :key="index" :style="formatData.selFontStyle">
                <h5 v-if="item.projectTitle || item.startYear || item.startMonth || item.endYear || item.endMonth">{{
                  item.projectTitle }}<span><template v-if="item.startYear">{{ item.startYear}}年</template> <template
                      v-if="item.startMonth">{{ item.startMonth }}月</template> <template
                      v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{
                      item.endYear}}年</template> <template v-if="item.endMonth">{{ item.endMonth }}月</template></span>
                </h5>
                <pre :style="formatData.selFontStyle">{{ item.contentsOfProject }}</pre>
              </div>
            </div>
          </div>

          <h2 v-if="formatData.prMessage">自己PR</h2>
          <div v-if="formatData.prMessage" class="prMessage" id="pr-message" :data-highlight="highlightMessage"
            @click="goCardTo('pr-message')" :class="highLightClass('pr-message')">
            <!-- <div class="label">{{ currentCardId }} {{ isCardChanged }}testtesttest</div> -->
            <pre :style="formatData.selFontStyle">{{ formatData.prMessage }}</pre>
          </div>

          <h2 v-if="formatData.imageItems" id="imag-pr">画像PR</h2>
          <div v-if="formatData.imageItems" class="img-pr" id="job-image" :data-highlight="highlightMessage"
            @click="goCardTo('job-image')" :class="highLightClass('job-image')">

            <!--アピールポイント-->
            <div class="img-prBlock" v-for="(item, index) in formatData.imageItems" :key="index"
              :style="formatData.selFontStyle" style="margin-bottom: 25px;">
              <div class="img-prText"
                style="display: flex; align-items: flex-start; justify-content: space-around; margin-bottom: 15px;">
                <img :src="item.mainImage" alt="アピール画像メイン" class="img-prImage" v-if="item.mainImage"
                  style="width: 300px; height: 200px; object-fit: cover; margin-right: 15px;">
                <div class="img-prTextblock" style="width: calc(100% - 300px);">
                  <h3 style="margin-top: 0;" v-if="item.title">{{ item.title }}</h3>
                  <pre :style="formatData.selFontStyle" style="margin-bottom: 5px;">{{ item.tools }}</pre>
                  <pre :style="formatData.selFontStyle">{{ item.description }}</pre>
                </div>
              </div>

              <!--課金ポイント↓-->
              <ul v-if="getSubImages(item).length > 0" style="list-style:none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 10px; justify-content: flex-start;">
                <li v-for="n in getValidSubImages(item)" :key="n" style="width: calc((100% - 40px) / 5);">
                  <img :src="item[`subImage${n}`]" class="img-prImage"
                    style="width: 100%; height: 150px; object-fit: cover;">
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShokurekishoPreviewMixin from '@/mixins/shokurekisho-preview-mixin'
export default {
  name: 'shokurekishoPreview',
  mixins: [ShokurekishoPreviewMixin],
  data: function () {
    return {}
  },
  computed: {
    subImages () {
      if (!this.item) return []
      return Array.from({ length: 5 }, (_, i) => i + 1)
        .filter(n => this.item[`subImage${n}`] && this.item[`subImage${n}`].length > 0)
    }
  },
  methods: {
    checkValid: function () {
    },
    getSubImages (item) {
      if (!item) return []
      return Array.from({ length: 5 }, (_, i) => i + 1)
        .filter(n => item[`subImage${n}`] && item[`subImage${n}`].length > 0)
    },
    getValidSubImages (item) {
      if (!item) return []
      return Array.from({ length: 5 }, (_, i) => i + 1)
        .filter(n => item[`subImage${n}`] && item[`subImage${n}`].length > 0)
    }
  }
}
</script>
